export default __webpack_public_path__ + "locales/it/Common.json?hash=3d0f4ad198ef11e308e162185cf40415";